export default "__VITE_ASSET__9RjS6mRe__"